export default __webpack_public_path__ + "static/media/6.cf45bd7e.jpg";